export default "__VITE_ASSET__BuaXblzf__"